export const CLEAR_FILTERS = 'agentsPwa/Filters/CLEAR_FILTERS';
export const RESTORE_PREVIOUS_FILTERS =
  'agentsPwa/Filters/RESTORE_PREVIOUS_FILTERS';
export const UPDATE_FILTER = 'agentsPwa/Filters/UPDATE_FILTER';
export const SUBMIT_FILTERS = 'agentsPwa/Filters/SUBMIT_FILTERS';

export const CONTRACT_DATE_FILTER_MAX_DAYS = 30;
